module.exports = __webpack_public_path__ + "img/no-search.f3d5b7bd.png";